import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {apiConfig} from '../../api-url.config';
import {FormGroup} from '@angular/forms';
import {CommonService} from '../../core/services/common.service';
import {LOCAL_STORAGE, SESSION_STORAGE, StorageService} from 'ngx-webstorage-service';
import {SocialAuthService} from 'angularx-social-login';

@Injectable()
export class AuthenticationService extends CommonService {
  API_END_POINT: string;


  constructor(private httpClient: HttpClient, @Inject(LOCAL_STORAGE) private storage: StorageService,
              private authService: SocialAuthService,) {
    super();
    this.API_END_POINT = environment.API_SERVER;
  }

  mobileLogin(payload: any) {
    return this.httpClient.post(`${this.API_END_POINT}${apiConfig.login}`, payload)
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  logout() {
    this.authService.signOut();
    this.storage.clear();
  }

  channelUserLogin(payload: any) {
    return this.httpClient.post(`${this.API_END_POINT}${apiConfig.channelUserLogin}`, payload)
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  sendOTP(value: any, otpSendParams: { version: string }) {
    let params = this.generateHttpParams(otpSendParams);
    return this.httpClient.post(`${this.API_END_POINT}${apiConfig.sendOTP}`, value, {params})
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  verifyOTP(value: any, otpParams: any) {
    let params = this.generateHttpParams(otpParams);
    return this.httpClient.post(`${this.API_END_POINT}${apiConfig.verifyOTP}`, value, {params})
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  updateUserFcmToken(userId: string, query: any, payload: any) {
    let params = this.generateHttpParams(query);
    return this.httpClient.put(`${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.tokenUpdate}`, payload, {params})
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
}
